/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimVisualReferenceVisualReferenceRect
 */
export interface TimVisualReferenceVisualReferenceRect {
    /**
     * 
     * @type {number}
     * @memberof TimVisualReferenceVisualReferenceRect
     */
    minX: number;
    /**
     * 
     * @type {number}
     * @memberof TimVisualReferenceVisualReferenceRect
     */
    minY: number;
    /**
     * 
     * @type {number}
     * @memberof TimVisualReferenceVisualReferenceRect
     */
    maxX: number;
    /**
     * 
     * @type {number}
     * @memberof TimVisualReferenceVisualReferenceRect
     */
    maxY: number;
}

/**
 * Check if a given object implements the TimVisualReferenceVisualReferenceRect interface.
 */
export function instanceOfTimVisualReferenceVisualReferenceRect(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "minX" in value;
    isInstance = isInstance && "minY" in value;
    isInstance = isInstance && "maxX" in value;
    isInstance = isInstance && "maxY" in value;

    return isInstance;
}

export function TimVisualReferenceVisualReferenceRectFromJSON(json: any): TimVisualReferenceVisualReferenceRect {
    return TimVisualReferenceVisualReferenceRectFromJSONTyped(json, false);
}

export function TimVisualReferenceVisualReferenceRectFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimVisualReferenceVisualReferenceRect {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minX': json['minX'],
        'minY': json['minY'],
        'maxX': json['maxX'],
        'maxY': json['maxY'],
    };
}

export function TimVisualReferenceVisualReferenceRectToJSON(value?: TimVisualReferenceVisualReferenceRect | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'minX': value.minX,
        'minY': value.minY,
        'maxX': value.maxX,
        'maxY': value.maxY,
    };
}

